import { useMutation, useQuery } from '@apollo/client';
import {
	GET_ASK_REV_QUERY_HISTORY,
	SAVE_ASK_REV_QUERY,
} from 'queries/gqlAskRev';

interface UseAskRevHistoryProps {
	propertyId?: string;
	userId?: string;
}

export const useAskRevHistory = ({
	propertyId,
	userId,
}: UseAskRevHistoryProps) => {
	return useQuery(GET_ASK_REV_QUERY_HISTORY, {
		variables: { propertyId, userId },
		skip: !propertyId || !userId,
		fetchPolicy: 'cache-and-network',
	});
};

export const useSaveAskRevQuery = () => {
	const [saveAskRevQuery, { data, loading, error }] = useMutation(
		SAVE_ASK_REV_QUERY,
		{
			refetchQueries: [GET_ASK_REV_QUERY_HISTORY],
			awaitRefetchQueries: true,
		},
	);

	return {
		saveAskRevQuery,
		data,
		loading,
		error,
	};
};
